import lazyWithPreload from 'react-lazy-with-preload';

const CameraDetailPrintShotPage = lazyWithPreload(
    () => import('./pages/camera-detail-print-shot/CameraDetailPrintShotPage')
);
const CameraReportPage = lazyWithPreload(() => import('./pages/camera-report/CameraReportPage'));
const ComparePrintShotPage = lazyWithPreload(() => import('./pages/compare-print-shot/ComparePrintShotPage'));
const ProgressReportPrintShotPage = lazyWithPreload(
    () => import('./pages/progress-report-print-shot/ProgressReportPrintShotPage')
);
const ProjectReportPage = lazyWithPreload(() => import('./pages/project-report/ProjectReportPage'));
const KhanSahebCameraViewerPage = lazyWithPreload(
    () => import('./pages/khan-saheb-camera-viewer/KhanSahebCameraViewerPage')
);

const InactiveUserUnsubscribeEmail = lazyWithPreload(
    () => import('./pages/inactive-user-unsubscribe-email/InactiveUserUnsubscribeEmail')
);

const ProcoreAuthorizationPage = lazyWithPreload(
    () => import('./pages/procore-authorization/ProcoreAuthorizationPage')
);

const WhatsappLiveLapsePage = lazyWithPreload(() => import('./pages/whatspapp-livelapse/WhatsappLiveLapsePage'));

const Routes = [
    {
        path: 'camera-printshot',
        element: <CameraDetailPrintShotPage />,
    },
    {
        path: 'compare-printshot',
        element: <ComparePrintShotPage />,
    },
    {
        path: 'progress-printshot',
        element: <ProgressReportPrintShotPage />,
    },
    {
        path: 'pdfs/camera-report',
        element: <CameraReportPage />,
    },
    {
        path: 'pdfs/project-report',
        element: <ProjectReportPage />,
    },
    {
        path: 'inactive-user-unsubscribe-email',
        element: <InactiveUserUnsubscribeEmail />,
    },
    {
        path: 'gridwall/khansaheb',
        element: <KhanSahebCameraViewerPage />,
    },
    {
        path: 'procore-authorization',
        element: <ProcoreAuthorizationPage />,
    },

    {
        path: 'public/:livelapseId',
        element: <WhatsappLiveLapsePage />,
    },
];

export default Routes;
